import React from 'react';
import { getOrUndefined } from 'util/resource';
import Avatar from 'ui/elements/avatars/Avatar';
import { useSelfUserProfile } from 'apis/CompanyAPI/users/useSelfUserProfile';
import { CommunityLisItemDetailed } from 'types/company/community';
import AvatarGroup from 'ui/elements/avatars/AvatarGroup';
import { getDefaultProfileImage } from 'ui/domain/Logo';

export function MyCommunityMembershipStatus({
  community,
  style,
}: {
  community: CommunityLisItemDetailed;
  style?: React.CSSProperties;
}) {
  const visibleCompanies = community.myCompanyMemberships
    .filter(m => m.visibility === 'Visible')
    .map(m => m.company);
  const pendingCompanies = community.myCompanyMemberships
    .filter(m => m.visibility === 'Pending')
    .map(m => m.company);

  const roles = community.roles.filter(r => r !== 'company_admin_in_community');

  const { resource: userProfileResource } = useSelfUserProfile();

  const memberTexts = [
    visibleCompanies.length === 1 && `${visibleCompanies[0].name} is a member`,
    visibleCompanies.length > 1 && `${visibleCompanies.length} companies are members`,
    pendingCompanies.length === 1 && `${pendingCompanies[0].name} is pending approval`,
    pendingCompanies.length > 1 && `${pendingCompanies.length} companies are pending approval`,
    roles.length > 0 && `You are ${roles.includes('company_master') ? 'an admin' : 'a member'}`,
    community.isPendingAsUser && 'You are pending approval',
  ]
    .filter(Boolean)
    .join(', ');

  return (
    <div style={style} className="u-flex u-flex-align-center u-flex--gap-half text-grey text-micro">
      <AvatarGroup max={3} size={24}>
        {visibleCompanies.map(company => (
          <Avatar
            key={company.id}
            borderColor="grey"
            size={24}
            imageUrl={company.logoURL}
            userName={company.name}
          />
        ))}
        {pendingCompanies.map(company => (
          <Avatar
            key={company.id}
            borderColor="grey"
            size={24}
            imageUrl={company.logoURL || getDefaultProfileImage('company')}
            userName={company.name}
          />
        ))}
        {roles.length > 0 && (
          <Avatar
            borderColor="grey"
            size={24}
            imageUrl={getOrUndefined(userProfileResource)?.imageUrl}
            userName={getOrUndefined(userProfileResource)?.name}
          ></Avatar>
        )}

        {community.isPendingAsUser && (
          <Avatar
            size={24}
            borderColor="grey"
            imageUrl={getOrUndefined(userProfileResource)?.imageUrl}
            userName={getOrUndefined(userProfileResource)?.name}
          ></Avatar>
        )}
      </AvatarGroup>
      {memberTexts}
    </div>
  );
}
